module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAYAAAAVBmHYAAAABHNCSVQICAgIfAhkiAAAANtJREFUSInt1D1OQkEYheEXuI0FlYGGhBhbMZTQEKDHuA4XYOciXAQJyyAUlrY09NS6gtfGkjs/98YCM6f95nsyOZlMh8yoG+AJmAH3QL/m6LzKQMfAFlik7iTh6gOwBwapcBKujoADcJsDA3QTzuyawFFcXZHRcRYOvDSFg1F76pf1OauPTfG7AKz6GjNCtQwju6c2+E1k1zZ46/wpXv2+5UuZRnYn6ndg/tlRo901zPx6Oy/4xVTAumY2Bd4Du2/AR2B+rJ2oy8jH9Ry7+fV2XvCCF7zgBf8f+A/QNpFgjhKBFwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/facebook.png
// module id = p8ve
// module chunks = 1